import { EffectCallback, useEffect } from 'react';

const useMountEffect = (callback: EffectCallback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};

export default useMountEffect;
